import create from "zustand";
import { ReportFilter, ReportFilterOperator } from "@/components/Reports/CustomReports/ReportFilterState";

type PartialRecord<K extends keyof any, T> = {
    [P in K]?: T;
};
interface ReportFilterState extends PartialRecord<string, ReportFilter> {
    status?: any;
    createdAt?: {
        operator: ReportFilterOperator;
        value: string[] | number[];
    };
    context?: {
        operator: ReportFilterOperator.EQ;
        value: "report" | "questionnaire" | "memberships" | "ware_gross_sales" | "ware";
    };
    expand?: any;
    product?: { operator: ReportFilterOperator; value: string[] };
}
interface CustomReportStoreState {
    initialFilter: ReportFilterState;
    currentFilter: ReportFilterState;
    setCurrentFilter: (filter: ReportFilterState) => void;
    setInitialFilter: (filter: ReportFilterState) => void;
    cleanFilter: () => void;
}
export const useCustomReportStore = create<CustomReportStoreState>((set) => ({
    initialFilter: {},
    currentFilter: {},
    setCurrentFilter(filter) {
        set({ currentFilter: filter });
    },
    setInitialFilter(filter) {
        set({ initialFilter: filter });
    },
    cleanFilter() {
        set({ currentFilter: {}, initialFilter: {} });
    },
}));
